import React, { Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { store } from './app/store'
import { Provider } from 'react-redux'
import { I18nextProvider } from 'react-i18next'
import i18next from 'i18next'
import HttpApi from 'i18next-http-backend'
import { formId, element, lang, langNamespace, theme, frontendDomain } from './dom'
import { CircularProgress, Fade, ThemeProvider } from '@mui/material'
import { getTheme } from './theme/cockpitTheme'
import { CacheProvider } from '@emotion/react'
import createCache from "@emotion/cache";

if (formId) {
    const i18n = i18next.createInstance()
    i18n
        .use(HttpApi)
        .init({
            interpolation: { escapeValue: false },  // React already does escaping
            lng: lang,
            fallbackLng: 'en',
            ns: langNamespace ? [langNamespace, 'leads'] : ['leads'],
            defaultNS: langNamespace ? langNamespace : 'leads',
            fallbackNS: 'leads',
            backend: {
                loadPath: frontendDomain + '/language/{{ns}}.{{lng}}.json'
            },
        })

    const shadowContainer = element.attachShadow({ mode: 'open' });
    const shadowRootElement = document.createElement('div');
    shadowContainer.appendChild(shadowRootElement);
    const cache = createCache({
        key: 'css',
        prepend: true,
        container: shadowContainer,
    });
    const muiTheme = getTheme(theme, shadowRootElement)
    ReactDOM.createRoot(shadowContainer).render(
        <React.StrictMode>
            <CacheProvider value={cache}>
                <Suspense fallback={<Fade
                    in={true}
                    style={{
                        transitionDelay: '800ms',
                    }}
                    unmountOnExit
                >
                    <CircularProgress/>
                </Fade>}>
                    <I18nextProvider i18n={i18n}>
                        <ThemeProvider theme={muiTheme}>
                            <Provider store={store}>
                                <App formId={formId}/>
                            </Provider>
                        </ThemeProvider>
                    </I18nextProvider>
                </Suspense>
            </CacheProvider>
        </React.StrictMode>
    )
}
